import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  expenses: "/expenses",
};

export const fetchExpenses = createAsyncThunk(
  "expenses/fetchExpenses",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.expenses, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const createExpense = createAsyncThunk(
  "expenses/createExpense",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.expenses, data);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const updateExpense = createAsyncThunk(
  "expenses/updateExpense",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.expenses}/${data.id}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const deleteExpense = createAsyncThunk(
  "expenses/deleteExpense",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`${endpoint.expenses}/${id}`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const patchExpense = createAsyncThunk(
  "expenses/patchExpense",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        `${endpoint.expenses}/${data.id}/settlement`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
